export default {
  date (isoString) {
    let date = new Date(isoString)
    return [[Number((date.getFullYear().toString())), date.getMonth() + 1, date.getDate()].join('-')].join(' ').replace(/(?=\b\d\b)/g, '0')
  },
}
